import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () => 'looplist' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  iteratorKey: keyAuto(),
  list: [],
});

const { getStore, defaultStore } = createComponentStore({
  type: 'loop_through_list',
  endpoint: 'loop-through-list',
  registryKey: 'loop-through-list',
  initData,

  onLoadData: (rawData) => {
    // v1 compat: data was an array of {key, list, ...}; v2 is flat {iteratorKey, list}
    if (Array.isArray(rawData)) {
      const first = rawData[0] || {};
      return {
        iteratorKey: first.key || first.iteratorKey || keyAuto(),
        list: first.list || [],
      };
    }
    const data = { ...rawData };
    if (data.key && !data.iteratorKey) { data.iteratorKey = data.key; delete data.key; }
    return data;
  },

  extraState: () => ({
    position: null,
    field: null,
    posiCondition: null,
    posiConditionIsMet: null,
  }),

  extraActions: (set) => ({
    setComponentName: (name) => set({ name }),

    setFocus: (index, field) =>
      set({ position: index, field, posiCondition: null, posiConditionIsMet: null }),

    setFocusCondition: (index, posi, type) => {
      const updates = { position: index };
      if (type === 'conditions') updates.posiCondition = posi;
      if (type === 'conditionIsMet') updates.posiConditionIsMet = posi;
      set(updates);
    },

    setComponent: (value, index, type) => {
      set((s) => {
        const data = { ...s.data };
        switch (type) {
          case 'key':
            data.iteratorKey = value;
            break;
          case 'list':
            if (value) data.list = [...(data.list || []), value];
            break;
          default:
            break;
        }
        return { data };
      });
    },

    deleteChip: (indexChip, index, field) => {
      set((s) => {
        const data = { ...s.data };
        const list = [...(data.list || [])];
        list.splice(indexChip, 1);
        data.list = list;
        return { data };
      });
    },
  }),
});

export const getLoopThroughListStore = getStore;
export default defaultStore;
